// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__tp_8B g-grid-container","logos":"style_logos__V2LkN"};